import React from 'react';
import { useFormikContext } from 'formik';

import { useUnsavedChangesPrompt } from 'hooks';

// PLA-8318: Formik-aware wrapper around useUnsavedChangesPrompt. Drop inside
// any <Formik>'s render-prop tree to enable the leave-without-saving guard.
const FormikUnsavedChangesGuard: React.FC = () => {
  const { dirty, isSubmitting } = useFormikContext();
  useUnsavedChangesPrompt({ when: dirty && !isSubmitting });
  return null;
};

export default FormikUnsavedChangesGuard;
